import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop component - Automatically scrolls to the top of the page
 * whenever the user navigates to a new route.
 * 
 * This component should be placed inside the Router but outside of Switch/Routes
 * to ensure it triggers on every route change.
 */
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to the very top of the page on route change
    // Using document.documentElement.scrollTo for better cross-browser compatibility
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // Immediate scroll without animation for better UX on navigation
    });
    
    // Fallback for older browsers
    window.scrollTo(0, 0);
  }, [pathname]); // Re-run effect whenever the pathname changes

  // This component doesn't render anything visible
  return null;
}

export default ScrollToTop; 